import { haptic } from '@/lib/haptics'

export function playDoneSound() {
  if (typeof window === 'undefined') return
  try {
    const ctx = new AudioContext()
    const now = ctx.currentTime

    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)

    osc.type = 'sine'
    osc.frequency.setValueAtTime(600, now)
    osc.frequency.setValueAtTime(900, now + 0.07)

    gain.gain.setValueAtTime(0, now)
    gain.gain.linearRampToValueAtTime(0.14, now + 0.01)
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.28)

    osc.start(now)
    osc.stop(now + 0.28)
    osc.onended = () => ctx.close()

    haptic('success')
  } catch {}
}

// Composer "added" blip: a soft, short downward plink, quieter than the done chime.
export function playCreatedSound() {
  if (typeof window === 'undefined') return
  haptic('light')
  try {
    const ctx = new AudioContext()
    const now = ctx.currentTime

    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)

    osc.type = 'triangle'
    osc.frequency.setValueAtTime(1100, now)
    osc.frequency.exponentialRampToValueAtTime(700, now + 0.06)

    gain.gain.setValueAtTime(0, now)
    gain.gain.linearRampToValueAtTime(0.06, now + 0.006)
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.12)

    osc.start(now)
    osc.stop(now + 0.12)
    osc.onended = () => ctx.close()
  } catch {}
}

// Soft bell for a finished timer: two decaying sine partials.
export function playBellSound() {
  if (typeof window === 'undefined') return
  try {
    const ctx = new AudioContext()
    const now = ctx.currentTime
    for (const [freq, peak, len] of [
      [660, 0.12, 1.6],
      [1320, 0.05, 1],
    ] as const) {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.connect(gain)
      gain.connect(ctx.destination)
      osc.type = 'sine'
      osc.frequency.setValueAtTime(freq, now)
      gain.gain.setValueAtTime(0, now)
      gain.gain.linearRampToValueAtTime(peak, now + 0.01)
      gain.gain.exponentialRampToValueAtTime(0.001, now + len)
      osc.start(now)
      osc.stop(now + len)
      if (freq === 660) osc.onended = () => ctx.close()
    }
    haptic('success')
  } catch {}
}

// Between poses in a played flow: one quiet, rounded tone.
export function playSoftChime() {
  if (typeof window === 'undefined') return
  try {
    const ctx = new AudioContext()
    const now = ctx.currentTime
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.type = 'sine'
    osc.frequency.setValueAtTime(528, now)
    gain.gain.setValueAtTime(0, now)
    gain.gain.linearRampToValueAtTime(0.06, now + 0.04)
    gain.gain.exponentialRampToValueAtTime(0.001, now + 1.2)
    osc.start(now)
    osc.stop(now + 1.2)
    osc.onended = () => ctx.close()
    haptic('light')
  } catch {}
}
